// Mirrors backend/config/permissions.js. The authoritative list is still
// fetched from GET /api/admins/permissions; this is just a fallback/reference
// used for local nav-building before that call resolves.
export const FALLBACK_PERMISSIONS = [
  { key: "manage_users", label: "Manage Users", group: "Users" },
  { key: "view_users", label: "View Users", group: "Users" },
  { key: "manage_products", label: "Manage Products", group: "Catalog" },
  { key: "view_products", label: "View Products", group: "Catalog" },
  { key: "manage_orders", label: "Manage Orders", group: "Orders" },
  { key: "view_orders", label: "View Orders", group: "Orders" },
  { key: "manage_payments", label: "Manage Payments", group: "Finance" },
  { key: "view_reports", label: "View Reports", group: "Finance" },
  { key: "manage_content", label: "Manage Content / CMS", group: "Content" },
  { key: "manage_notifications", label: "Manage Notifications", group: "Content" },
  { key: "manage_settings", label: "Manage Settings", group: "System" },
  { key: "manage_salespersons", label: "Manage Sales Team", group: "Distribution Network" },
];
